<template>
  <div class="psychological-teachers-use">
    <div class="record-title" style="margin-bottom: 20px">心理老师使用数据</div>
    <CoachingCoreData :dataSource="coachingCoreData" />
    <div class="title-1" style="margin: 20px 0 10px">{{ title }}</div>
    <div class="flex-between">
      <span>
        未采集到的学生共
        <span style="font-size: 16px; font-weight: bold; color: #fa3a25">
          {{ faceCollectInfo.faceNotGatherCount }}
        </span>
        人
      </span>
      <span style="color: #2a82e4; cursor: pointer" @click="viewModal">
        查看详情
        <a-icon type="right" />
      </span>
    </div>
    <div class="tip" style="margin: 12px 0 5px">
      <span>
        <img
          src="@/assets/imgs/school/monthRecord/warningMark.png"
          alt=""
          style="width: 14px; height: 14px; margin-right: 5px"
        />
        本月未采集到学生共{{ faceCollectInfo.faceNotGatherCount }}人，其中有底图未采集的{{
          faceCollectInfo.haveFaceNotGather
        }}人，无底图的{{
          faceCollectInfo.withOutFaceNotGather
        }}人，请确认是否有请假、休学、外出、课间活动量少的情况，建议持续关注或更新底图。
      </span>
    </div>
    <TableList
      style="width: 100%; margin-top: 5px"
      :columns="columns"
      :tableData="dataSource"
      :loading="loading"
      :scroll="{}"
    />
    <!--详情模态框-->
    <DetailModal ref="detailModalRef" :title="title" :columns="columns" :url="url" />
  </div>
</template>
<script>
import CoachingCoreData from './components/CoachingCoreData.vue'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import TableList from '@comp/chart/TableList.vue'
import DetailModal from '@views/school/PsychologicalMonthReport/components/DetailModal.vue'
import {
  getStudentCounselingDataByTime,
  queryStudentsWithoutFaceStatistics,
} from '@/api/monthReport'

export default {
  name: 'TeacherUseData',
  mixins: [JeecgListMixin],
  components: {
    DetailModal,
    TableList,
    CoachingCoreData,
  },
  props: {
    title: {
      type: String,
      default: '本月未采集到学生名单',
    },
    dateRange: {
      type: Object,
      default: () => ({}),
    },
    coachingCoreInfo: {
      type: Object,
      default: () => ({}),
    },
    faceCollectInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      disableMixinCreated: true,
      // 未采集学生数据、导出
      url: {
        list: '/emotionalReport/queryStudentsWithoutFace',
        exportXlsUrl: '/emotionalReport/queryStudentsWithoutFacedExport',
      },
      columns: [
        {
          title: '班级',
          dataIndex: 'className',
          align: 'center',
        },
        {
          title: '学生姓名',
          dataIndex: 'studentName',
          align: 'center',
        },
        {
          title: '关爱学生',
          dataIndex: 'careList',
          align: 'center',
        },
        {
          title: '是否有底图',
          dataIndex: 'pic',
          align: 'center',
        },
      ],
      coachingCoreData: [],
    }
  },
  watch: {
    dateRange(dateObj) {
      this.queryParam = {
        startTime: dateObj.beginDate,
        endTime: dateObj.endDate,
      }
      this.loadData(1)
    },
  },
  methods: {
    // 由父组件调用
    async getStudentCounselingDataByTime() {
      const { success, result } = await getStudentCounselingDataByTime(this.queryParam)
      if (success) {
        const {
          mentalBookingRate,
          parentBookingTotal,
          teacherBookingTotal,
          totalAppointNum,
          tutoredCount,
          //心理老师自主辅导次数
          psychologistActiveCounselingCount,
          //心理老师家访次数
          psychologistHomeVisitCount
        } = result
        this.coachingCoreData = [
          {
            icon: 'processingRate',
            label: '心理辅导预约处理率',
            value: mentalBookingRate,
          },
          {
            icon: 'coach',
            label: '心理预约已辅导',
            value: tutoredCount,
          },
          {
            icon: 'tinkerBell',
            label: '总辅导次数',
            value: totalAppointNum,
          },
          {
            icon: 'crisisReporting',
            label: '危机上报',
            value: this.coachingCoreInfo.crisisReportStudentCount,
          },
          {
            icon: 'makeAppointment',
            label: '自主辅导次数',
            value: psychologistActiveCounselingCount,
          },
          {
            icon: 'parentalAppointment',
            label: '家访次数',
            value: psychologistHomeVisitCount,
          },
          // {
          //   icon: 'makeAppointment',
          //   label: '班主任预约',
          //   value: teacherBookingTotal,
          // },
          // {
          //   icon: 'parentalAppointment',
          //   label: '家长预约',
          //   value: parentBookingTotal,
          // },
          // {
          //   icon: 'gradeLeaderAppointment',
          //   label: '年级组长预约',
          //   value: 0,
          // },
        ]
      }
    },
    viewModal() {
      this.$refs.detailModalRef.showModal(this.queryParam)
    },
  },
}
</script>
<style scoped lang="less">
.psychological-teachers-use {
  padding: 20px;
  background-color: #fff;
  border-radius: 10px;
  .tip {
    padding: 15px;
    border-radius: 10px;
    line-height: 1.8;
    background-color: #fefce8;
  }
}
</style>
